<template>
  <WellModalContent 
    class="checkout-modal-content"
    @close="$attrs._close()"
  >
    <div v-if="!paymentSuccess" class="flex flex-col lg:flex-row">
      <!-- Right side: Event details and summary (moved to top for smaller screens) -->
      <div class="w-full lg:w-1/2 lg:order-2">
        <div class="relative hidden lg:block">
          <img :src="props.event.photo1" alt="Event Image" class="w-full aspect-square object-cover">
          <div class="absolute top-0 left-0 right-0 text-dark p-4">
            <EventTypeTag
              class="relative"
              :eventType="props.event.eventType"
              :eventTag="props.event.typeTag"
            />
          </div>
          <div class="absolute bottom-0 left-0 right-0 bg-dark text-primary-contrast p-4">
            <h3 class="text-2xl my-2">{{ props.event.event_name }}</h3>
            <div class="flex items-center">
              <EventDate :date="props.event.dateShort" class="mr-4"/>
              <EventTime :time="props.event.time" />                
            </div>
          </div>
        </div>
        
        <div class="p-6 pt-10 lg:pb-20 lg:bg-white h-100">
          <span class="mb-2 hidden lg:block">SUMMARY</span>
          <p class="lg:hidden mb-4">CHECKOUT</p>
          <div class="flex justify-between flex-nowrap pb-5 border-b border-dark text-dark-gray">
            <span class="flex flex-wrap mr-6">1 ticket to {{ props.event.event_name }} {{ props.event.instructorsString ? `- ${props.event.instructorsString}` : '' }}</span>
            <span class="flex flex-nowrap text-nowrap flex-1 justify-end">USD ${{ props.event.www_price }}</span>
          </div>
          <!-- <div class="flex justify-between my-2">
            <span>Subtotal</span>
            <span>USD ${{ props.event.www_price }}</span>
          </div>
          <div class="flex justify-between pb-4 border-b border-gray-300">
            <span>Fees</span>
            <span>USD $0.00</span>
          </div> -->
          <div class="flex justify-between text-xl mt-6">
            <span>TOTAL</span>
            <span>USD ${{ props.event.www_price }}</span>
          </div>
        </div>
      </div>

      <!-- Left side: Checkout information -->
      <div class="w-full lg:w-1/2 p-6 pt-2 lg:p-8 lg:order-1 bg-primary-contrast">
        <p class="hidden lg:block">CHECKOUT</p>
        <form @submit.prevent="handleSubmit" class="flex flex-col gap-4 lg:mt-5">
          <div 
            v-if="userStore.isLoggedIn"
            class="flex flex-row justify-between items-center flex-nowrap border border-dark p-4 mb-4" 
          >
            <div class="flex flex-col">
              <span class="text-sm text-gray-600">LOGGED IN AS:</span>
              <h2 class="text-2xl mt-2">{{ student?.first_name }} {{ student?.last_name }}</h2>
            </div>
            <button 
              class="text-sm text-gray-600 border border-dark rounded-lg px-4 py-3"
              @click="userStore.logout()"
            >
              LOGOUT
            </button>
          </div>
          <div 
            v-if="!userStore.isLoggedIn"
            class="flex flex-col"
          >
            <input
              v-model="email"
              type="email"
              id="email"
              placeholder="Email address"
              required
              class="bg-transparent rounded-lg border border-dark placeholder-gray-500 focus:outline-none p-2"
            />
          </div>
          <div 
            v-if="!userStore.isLoggedIn"
            class="flex flex-col sm:flex-row sm:space-x-4 space-y-4 sm:space-y-0"
          >
            <input
              v-model="firstName"
              type="text"
              id="firstName"
              placeholder="First name"
              required
              class="w-full sm:w-1/2 px-3 py-2 bg-transparent rounded-lg border border-dark placeholder-gray-500 focus:outline-none p-2"
            />
            <input            
              v-model="lastName"
              type="text"
              id="lastName"
              placeholder="Last name"
              required
              class="w-full sm:w-1/2 px-3 py-2 bg-transparent rounded-lg border border-dark placeholder-gray-500 focus:outline-none p-2"
            />
          </div>
          <div class="flex flex-col">
            <div class="flex items-start items-center">
              <input
                v-model="termsAgreed"
                type="checkbox"
                id="terms"
                class="mr-3 w-5 h-5 accent-dark"
                required
              />
              <label for="terms" class="text-sm">
                I agree to the <a href="https://www.heymarvelous.com/terms" target="_blank" class="underline">Terms and Conditions</a> and <a href="https://www.heymarvelous.com/privacy" target="_blank" class="underline">Privacy Policy</a>
              </label>
            </div>
          </div>
          <div class="flex flex-col">
            <div class="flex items-start items-center">
              <input
                v-model="marketingOptin"
                type="checkbox"
                id="terms"
                class="mr-3 w-5 h-5 accent-dark"
              />
              <label for="terms" class="text-sm">
                I agree to receive news and updates from this event organizer.
              </label>
            </div>
          </div>

          <div class="flex flex-col" v-if="!isFree">
            <label for="card-element" class="text-sm mb-1">Card Details</label>
            <div id="card-element" class="bg-transparent rounded-lg border border-dark p-3"></div>
            <span class="text-xs text-dark-gray flex items-center flex-row mt-4 gap-2">
                <WellIcon icon="lock-01" />
                This is a secure 256-bit SSL encrytped connection.
            </span>
          </div>
          <button
            type="submit"
            class="button-light-outlined"
            :disabled="processingPayment"
          >
            <template v-if="processingPayment">
              <WellIcon icon="hourglass-01" class="inline-block animate-spin mr-2"/>
              PROCESSING...
            </template>
            <template v-else>
              <span v-if="!isFree">COMPLETE CHECKOUT</span>
              <span v-else>REGISTER FOR FREE</span>
            </template>
          </button>
          <div class="flex flex-row justify-between items-center flex-wrap mt-6" v-if="!isFree">
            <div class="flex flex-row justify-start flex-nowrap mb-2">
                <img
                class="w-6 h-auto mr-2"
                src="/images/Visa.png"
                alt="Visa"
                />
                <img
                class="w-6 h-auto mr-2"
                src="/images/Amex.png"
                alt="American Express"
                />
                <img
                class="w-6 h-auto mr-2"
                src="/images/Mastercard.png"
                alt="Mastercard"
                />
                <img
                class="w-6 h-auto mr-2"
                src="/images/cartes-bancaires.png"
                />
            </div>
            <div class="flex items-center">
                <span class="text-sm text-gray-600">Checkout by</span>
                <img
                    class="w-16 h-6 ml-2"
                    src="/images/Stripe.png"
                    alt="Stripe"
                />
            </div>
          </div>
        </form>
        <div v-if="errorMessage" id="card-errors" class="text-red-500 mt-4">{{ errorMessage }}</div>        
      </div>
    </div>
    <div v-else class="flex flex-col justify-center items-center h-full px-10 py-10">
        <div class="flex flex-col items-center md:max-w-[400px]">
            <h2 class="text-3xl font-bold">Thanks for registering!</h2>
            <p class="mt-8">Check your email for details on the event. We’ll send you reminders and a link to access closer to the start time!</p>
        </div>
        <hr class="w-full mt-10 mx-20 border-dark" />
        <section class="w-full mx-20 mt-5 py-4">         
          <EventsSlider 
            :events="similarEvents"
            size="small"  
            class="mt-5"
          >
            <template #title>
              <span class="inline-flex gap-2 items-center">
                <WellIcon icon="lightbulb-02" />
                OTHER EVENTS YOU MIGHT LIKE
              </span> 
            </template>
          </EventsSlider>
        </section>
    </div>
  </WellModalContent>
</template>

<script setup lang="ts">
import WellIcon from '~/components/common/WellIcon.vue'
import WellModalContent from '~/components/common/WellModalContent.vue'
import EventDate from '@/components/events/EventDate.vue';
import EventTime from '@/components/events/EventTime.vue';
import EventTypeTag from '@/components/events/EventTypeTag.vue';
import EventCard from '@/components/events/EventCard.vue';
import EventsSlider from '@/components/events/EventsSlider.vue';
import { loadStripe } from '@stripe/stripe-js'
import { ref, onMounted, watch, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useModal } from '@/composables/useModal'
import { useUserStore } from '@/stores/user'
import type { EventDetails } from '@/utils/eventDetails'

const { hideAll } = useModal()
const config = useRuntimeConfig()
const recaptchaKey = config.public.VUE_APP_RECAPTCHA_KEY

const props = defineProps<{
  event: EventDetails,
  similarEvents: EventResponse[],
  onPurchase: () => void
}>()

const emit = defineEmits(['close'])

const route = useRoute()
const userStore = useUserStore()
const { createPaymentIntent, registerForEvent } = useApi()

const stripePromise = loadStripe(props.event.stripe_publishable_key)
const email = ref('')
const firstName = ref('')
const lastName = ref('')
const errorMessage = ref('')
const cardValid = ref(false)
const elements = ref(null)
const termsAgreed = ref(false)
const marketingOptin = ref(false)
const paymentSuccess = ref(false)
const processingPayment = ref(false)

const student = computed(() => userStore.student)

const isFree = computed(() => {
  const numPrice = typeof props.event.www_price === 'string' ? parseFloat(props.event.www_price) : props.event.www_price
  return numPrice === 0
})

const updateStudentInfo = (newStudent) => {
  if (newStudent) {
    email.value = newStudent.email || ''
    firstName.value = newStudent.first_name || ''
    lastName.value = newStudent.last_name || ''
  } else {
    email.value = ''
    firstName.value = ''
    lastName.value = ''
  }
}

watch(student, updateStudentInfo)

// Execute immediately if student is already present
if (student.value) {
  updateStudentInfo(student.value)
}

const checkoutEnabled = computed(() => {
  const isUserInfoPresent = !!firstName.value && !!lastName.value && !!email.value
  const isCardConditionOk = isFree.value || cardValid.value
  return (userStore.isLoggedIn || isUserInfoPresent) && isCardConditionOk && termsAgreed.value
})

watch(() => route.fullPath, () => {
    hideAll()
})

onMounted(async () => {
  if (isFree.value) return;  // no need to set up stripe if the event is free

  const stripe = await stripePromise
  const cardElementOptions = {
    style: {
      base: {
        fontSize: '16px',
        fontFamily: '"Archivo", sans-serif',
      }
    }
  }
  elements.value = stripe.elements({ fonts: [{ cssSrc: 'https://fonts.googleapis.com/css?family=Archivo' }] })
  const cardElement = elements.value.create('card', cardElementOptions)
  cardElement.mount('#card-element')

  cardElement.on('change', function(event) {
    const displayError = document.getElementById('card-errors');
    if (event.error) {
        errorMessage.value = event.error.message;
    } else {
        errorMessage.value = '';
        cardValid.value = true
    }
  });

})

const handleSubmit = async () => {
  if (!checkoutEnabled.value) {
    errorMessage.value = 'Please fill in all required fields and agree to the terms.'
    return
  }
  errorMessage.value = '';

  let paymentIintentId = ''
  let paymentMethodResponse: any = {}
  processingPayment.value = true
  if (!isFree.value) {
    errorMessage.value = ''

    const stripe = await stripePromise
    try {
      const reCaptchaToken = await window.grecaptcha.execute(recaptchaKey, {
          action: 'wwweventpaymentintent',
      });

      const { client_secret, payment_intent_id } = await createPaymentIntent(
        reCaptchaToken,
        props.event.id, 
        email.value, 
        firstName.value, 
        lastName.value
      )
      paymentIintentId = payment_intent_id
    } catch (error) {
      processingPayment.value = false
      if (error.data?.message) {
        errorMessage.value = error.data.message
      } else {
        errorMessage.value = 'Payment failed!'
      }
      console.error('Error registering for event:', error)
      return
    }

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: elements.value.getElement('card'),
      billing_details: {
        email: email.value,
        name: `${firstName.value} ${lastName.value}`
      }
    })
    paymentMethodResponse = paymentMethod
    if (error) {
      processingPayment.value = false
      errorMessage.value = error.message
      return
    }
  }

  try {
    const reCaptchaToken = await window.grecaptcha.execute(recaptchaKey, {
        action: 'wwwregistration',
    });

    const response: EventRegistrationResponse = await registerForEvent(
      email.value, 
      firstName.value, 
      lastName.value,
      reCaptchaToken, 
      marketingOptin.value,
      props.event.id,
      paymentIintentId, 
      paymentMethodResponse.id
    )
    paymentSuccess.value = true
    if (props.onPurchase) {
      props.onPurchase()
    }
  } catch (error) {
      processingPayment.value = false
      errorMessage.value = 'Payment or registration failed!'
      console.error('Error registering for event:', error)
  } finally {
    processingPayment.value = false
  }
}
</script>

<style lang="scss">

.checkout-modal-content {
  padding: 1.5rem 0 0 0 !important;  

  @screen lg {
    padding: 0 !important;  
    min-width: 920px !important;
    max-width: 920px !important;
  }

  .well-modal-content_body {
    padding: 0 !important;

    @screen md {
      padding: 0 !important;
    }
  }

  .well-modal-content-header__close {
    border-radius: 50%;
    background-color: #FAF8F480;
    padding: 4px;
  }
  
}
</style>
